import { connect } from '@atlassian/jira-react-redux';
import { setDependenciesViewVisibility } from '../../state/ui/views/actions';
import Flag from './view';

const onShowDependencies = () => setDependenciesViewVisibility(true);

export default connect(null, {
	onShowDependencies,
})(Flag);
